import React, { useContext, useEffect } from "react";
import { Link } from "react-router-dom";
import { AppContext } from "../utilities/context";
import { FormattedMessage, useIntl } from "react-intl";
import Container from "@mui/material/Container";
import Layout from "./Layout";
import Grid from "@mui/material/Grid";
import Styles from "../../public/assets/css/main.css";
import logo from "../../public/assets/images/detailLogo.png";
// import Chat from "./Chat";

const Home = () => {
  const context = useContext(AppContext);
  const intl = useIntl();

  useEffect(() => {
    if (context) {
      context.updateBreadcrumbsState([]);
    }
  }, []); // The empty dependency array means this effect will only run once (equivalent to componentDidMount)

  return (
    <Layout>
      <Container maxWidth={false} disableGutters>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={1}>
            &nbsp;
          </Grid>
          <Grid item xs={12} sm={10} sx={{ textAlign: "center" }}>
            <img src={logo} className={"AppLogoHome"} alt="logo" />
          </Grid>
          <Grid item xs={12} sm={1}>
            &nbsp;
          </Grid>
          <Grid item xs={12} sm={12} sx={{ textAlign: "center" }}>
            <Link to={"mailto:mborches@chatsense.pro"}>Contact</Link>
          </Grid>
        </Grid>
        {/* <Chat /> */}
      </Container>
    </Layout>
  );
};

export default Home;
